function fetchEventQuery (rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null
  id = rootQueryType === 'organisationalUnit' ? Number(id) : `${id}`

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null
  }

  let variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year)
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person
  }

  return {
    operationName: 'fetchEventQuery',
    query: `
      query fetchEventQuery($id: ID!, $pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:EventSortKeys, $filterYear:Int, $filterFreetext:String, $filterPerson:String) {
        ${rootQueryType}(id: $id) {
          veranstaltung:events(pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField, filter: {year: $filterYear freeText: $filterFreetext person:$filterPerson }) {
            meta {
              pageNumber
              pageSize
              totalEntries
              totalPages
            }
            entries {
              ... on Event {
                _id:id
                _entityName
                html {
                  de
                  en
                }
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchEventQuery }



// WEBPACK FOOTER //
// ./src/graphql/event.js